import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';

@Injectable()
export class GreenIdService {
  constructor(
    private http: HttpClient,
    public toastr: ToastrService,
  ) {}

  getVerificationToken(account: number): Observable<any> {
    return this.http.get(
      environment.apiUrl + 
        `/member-portal/memberIdentity/account/${account}/verificationtoken`
    );
  }

  validated(account: number, verificationId: string): Observable<any> {
    var obj = {
      accountId: account,
      verificationId: verificationId,
    };
    return this.http.post<any>(
      environment.apiUrl +
        `/member-portal/memberIdentity/account/${account}/verified`,
      obj
    );
  }

  recordConsent(account: number, verificationId: string): Observable<any> {
    var obj = {
      verificationId: verificationId,
    };
    return this.http.post<any>(
      environment.apiUrl +
        `/member-portal/memberIdentity/account/${account}/consent`,
      obj
    );
  }
}
